const DEFAULT_PRODUCTION_API_URL = "https://api.meet-manager.fr";

// Fonction pour obtenir l'URL du serveur WebSocket
export const getWebSocketUrl = (): string => {
  const configuredApiUrl = import.meta.env.VITE_API_URL?.trim();
  if (configuredApiUrl) return configuredApiUrl;

  // En développement, on utilise l'URL courante
  if (process.env.NODE_ENV !== "production") {
    const currentHost = window.location.hostname;
    const wsPort = "3001"; // Port du serveur WebSocket
    return `http://${currentHost}:${wsPort}`;
  }

  return DEFAULT_PRODUCTION_API_URL;
};
